import { enumToStaticValue } from '@/utils'
import { MoneyBoxType } from './moneyBoxType'

export default enumToStaticValue(MoneyBoxType, 'money-box-type')
